var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2985 14.1722C23.2985 12.1168 22.482 10.1455 21.0286 8.69212C19.5752 7.23872 17.6039 6.4222 15.5485 6.4222C13.4931 6.4222 11.5218 7.23872 10.0684 8.69212C8.61502 10.1455 7.7985 12.1168 7.7985 14.1722V24.5055H23.2985V14.1722ZM25.8818 25.3671L26.3985 26.0555C26.4705 26.1515 26.5143 26.2656 26.5251 26.385C26.5358 26.5045 26.5131 26.6246 26.4595 26.7319C26.4059 26.8391 26.3234 26.9294 26.2214 26.9924C26.1193 27.0555 26.0018 27.0889 25.8818 27.0889H5.21517C5.09523 27.0889 4.97766 27.0555 4.87563 26.9924C4.77361 26.9294 4.69116 26.8391 4.63752 26.7319C4.58388 26.6246 4.56117 26.5045 4.57195 26.385C4.58272 26.2656 4.62654 26.1515 4.6985 26.0555L5.21517 25.3671V14.1722C5.21517 11.4316 6.30386 8.80331 8.24173 6.86543C10.1796 4.92755 12.8079 3.83887 15.5485 3.83887C18.2891 3.83887 20.9174 4.92755 22.8553 6.86543C24.7931 8.80331 25.8818 11.4316 25.8818 14.1722V25.3671ZM12.3193 28.3805H18.7777C18.7777 29.237 18.4375 30.0583 17.8319 30.6639C17.2263 31.2695 16.4049 31.6097 15.5485 31.6097C14.6921 31.6097 13.8707 31.2695 13.2651 30.6639C12.6596 30.0583 12.3193 29.237 12.3193 28.3805Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white",
    transform: "translate(0.0488281 0.609619)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.66656c4b.svg";
export { ForwardRef as ReactComponent };